// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles-module__icon___qq4w8","body":"styles-module__body___3T8ag"};